/*
    本地存储的工具js
*/ 

export default {
    // 存,修改
    set(key,value){
        return sessionStorage.setItem(key,value);
    },
    // 取
    get(key){
        return sessionStorage.getItem(key);
    },
    // 删一条
    remove(key){
        return sessionStorage.removeItem(key);
    },
    // 清空
    clear(){
        return sessionStorage.clear();
    }
}




// WEBPACK FOOTER //
// ./src/utils/local.js